export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="55"
      data-name="Layer 1"
      viewBox="0 0 321 55"
    >
      <path
        d="M0 0h74.36v55H0z"
        data-name="Rectangle-path-+-Rectangle-69-+-Path-91-+-Oval-1"
        fill="rgb(224, 224, 224)"
      ></path>
      <g data-name="Rectangle-61-+-Rectangle-69-+-Path-91-+-Oval-1">
        <g data-name="Rectangle-61">
          <path
            d="M82 0h74.36v55H82z"
            data-name="Rectangle-path"
            fill="rgb(224, 224, 224)"
          ></path>
        </g>
      </g>
      <g data-name="Rectangle-61-+-Rectangle-69-+-Path-91-+-Oval-1">
        <g data-name="Rectangle-61-+-Rectangle-78">
          <g data-name="Rectangle-61">
            <path
              d="M246 0h74.36v55H246z"
              data-name="Rectangle-path"
              fill="rgb(224, 224, 224)"
            ></path>
          </g>
        </g>
        <g data-name="Rectangle-61-+-Rectangle-78">
          <g data-name="Rectangle-61">
            <path
              d="M164 0h74.36v55H164z"
              data-name="Rectangle-path"
              fill="rgb(224, 224, 224)"
            ></path>
          </g>
        </g>
      </g>
      <path
        d="M100 13h39v29h-39z"
        fill="rgb(211, 211, 211)"
      ></path>
      <path
        d="M139 42.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-2.5-1.5h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-1.5-2.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Z"
        fill="rgb(189, 189, 189)"
      ></path>
      <path
        d="M182 13h39v29h-39z"
        data-name="Rectangle-79"
        fill="rgb(211, 211, 211)"
      ></path>
      <path
        d="M221 42.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-2.5-1.5h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-1.5-2.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Z"
        fill="rgb(189, 189, 189)"
      ></path>
      <path
        d="M264 13h39v29h-39z"
        data-name="Rectangle-79"
        fill="rgb(211, 211, 211)"
        stroke="rgb(189, 189, 189)"
        strokeLinejoin="round"
        strokeDasharray={2}
      ></path>
      <path
        d="M264 13h39v29h-39z"
        data-name="Rectangle-79"
        fill="rgb(211, 211, 211)"
      ></path>
      <path
        d="M303 42.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-2.5-1.5h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-1.5-2.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Z"
        fill="rgb(189, 189, 189)"
      ></path>
      <path
        d="M18 13h39v29H18z"
        data-name="Rectangle-79"
        fill="rgb(211, 211, 211)"
      ></path>
      <path
        d="M57 42.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2ZM18.5 41h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1Zm-39-3h-1v-2h1Zm39-1h-1v-2h1ZM56 13.5h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Zm-4 0h-2v-1h2Z"
        fill="rgb(189, 189, 189)"
      ></path>
    </svg>
  );
};
